module.exports = __webpack_public_path__ + "static/media/gorgas.203f22e9.jpg";